export class StorageConstant {
  static LOCAL_STORAGE_DASHBOARD_STATUS = 'LOCAL_STORAGE_DASHBOARD_STATUS';
  static AUTH_USER = 'auth_token';
  static USER_DEVICE_KEY = 'UDK';
  static HidePriceStorageKey = 'MADAR_HIDE_PRICE';
  static COLUMN_OPTIONS_KEY = 'ColumnOptions';
  static DASHBOARD_ORDER_FULFILLMENT = 'DASHBOARD_ORDER_FULFILLMENT';
  static DASHBOARD_BUSINESS_STATUS = 'DASHBOARD_BUSINESS_STATUS';
  static DASHBOARD_ORDER_STATUS = 'DASHBOARD_ORDER_STATUS';
  static DASHBOARD_TOTAL_TRUCKS = 'DASHBOARD_TOTAL_TRUCKS';
  static DASHBOARD_TOTAL_DRIVERS = 'DASHBOARD_TOTAL_DRIVERS';
  static TEMP_TOKEN = 'TEMP_TOKEN';
  static HAS_DYNAMIC_FIELDS = 'HAS_DYNAMIC_FIELDS';
  static DYNAMIC_FIELDS = 'DYNAMIC_FIELDS';
  static ANNOUNCEMENT_BAR = 'ANNOUNCEMENT_BAR';
  static CUSTOMER_REGISTRATION_DRAFT = 'CUSTOMER_REGISTRATION_DRAFT';
}
